import { isEmpty } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
import { getDetails } from 'src/models/details/selectors';
import { RootState } from 'src/store';
import { getAllowedQuickActions } from './queries';

export const getReferredModules = (state: RootState) =>
  state?.details360?.referredModules;

export const getAuditHistory = (state: RootState) =>
  state?.details360?.auditHistory;

export const getHistory = (state: RootState) => state?.details360?.history;

export const getPhoneCallDetails = (state: RootState) =>
  state?.details360?.phoneCallDetails;

export const getRelatedRecords = (state: RootState, module) =>
  state?.details360?.relatedRecords[module];

export const getDetailsQuickAction = createSelector(
  [
    (state, entityId) => getDetails(state, entityId),
    (state, entityId, props) => props,
  ],
  (details, props) => {
    if (props.revyre && !isEmpty(details)) {
      const { quickActions = [], profiles = [] } = details ?? {};
      return getAllowedQuickActions(quickActions, profiles);
    }
    return [];
  },
);

export const getStatus = (state: RootState, key) =>
  state?.details360?.status[key] || '';

export const getTrails = (state: RootState) => state?.details360?.trails?.list;

export const getTotalTrails = (state: RootState) =>
  state?.details360?.trails?.meta?.totalCount || 0;

export const getNotification = (state: RootState) =>
  state?.details360?.uiState?.notification;
